import React, { useState } from "react";
import Moment from 'moment';
import filmIcon from '../../../../../assests/dashboard/friends/film.png'
import defaultShareProject from '../../../../../assests/dashboard/friends/defaultShareProject.png'
import classes from './ProjectShareDetails.module.css'
import { useSelector } from "react-redux";
import ProjectLibraryPopup from "../../../../lms-shared/UI/Popups/ProjectLibraryPopup/ProjectLibraryPopup";

const ProjectShareDetails = ({ dataPost, newPost, setNewPost, project, beenSharedBefore, setProjectData, updateContentPost }) => {

    const [showProjectLibraryPopup, setShowProjectLibraryPopup] = useState()

    const texts = useSelector(state => state.translate.texts);

    return (
        <div className={classes.ProjectDetailsContainer}>
            {!newPost ? <div className={classes.ProjectDetails} style={{ backgroundImage: project?.thumbnail ? `url(${project.thumbnail})` : `url(${defaultShareProject})` }}>
                <div className={classes.Details}>
                    <img src={filmIcon} alt='FilmIcon' />
                    <p className={classes.ProjectNameInImg} >{project?.name}</p>
                    {project?.createdDate && <p className={classes.DateInImg}>{Moment(project.createdDate).format('HH:mm')} | {Moment(project.createdDate).format('DD.MM.YY')}</p>}
                </div>
            </div> :
                <div className={classes.ProjectDetails} >
                    <button className={classes.OpenProjectLibraryBtn} onClick={() => setShowProjectLibraryPopup(true)}> +  בחר פרוייקט לשיתוף</button>
                </div>
            }
            {beenSharedBefore && <div className={classes.updateVersionContainer}>
                <p className={classes.UpdateVersionContent}>{dataPost?.hasChange ? texts.updateVersionContentWithChange : texts.updateVersionContent}</p>
                <button disabled={!dataPost?.hasChange} className={classes.BtnUpdateVersion} onClick={updateContentPost}>{texts.updateVersion} </button>
            </div>}
            {showProjectLibraryPopup && <ProjectLibraryPopup setNewPost={() => setNewPost(false)} close={() => setShowProjectLibraryPopup(false)} chooseProject={setProjectData} />}
        </div>
    )
}

export default ProjectShareDetails;